var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block bg-white text-nowrap pr-2"},[_c('span',{staticClass:"px-2"},[_vm._v(" "+_vm._s(_vm.averageRounded)+" ")]),_vm._l((_vm.starAmount),function(star,index){return _c('img',{key:index,staticClass:"star",attrs:{"src":star}})}),(_vm.count)?_c('span',{staticClass:"pl-2"},[_vm._v("("+_vm._s(_vm.count)+")")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }